import { render, staticRenderFns } from "./locationLogin.vue?vue&type=template&id=406b16a4&"
import script from "./locationLogin.vue?vue&type=script&lang=js&"
export * from "./locationLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports